module.exports = __webpack_public_path__ + "static/media/work-img10.2710643d.jpg";